
function Facilities() {
    return (
        <>
            <div className="dr-header">
                <div className="header-contant">
                    <h1> Facilities</h1>
                    <p>Doctor {" > "} Facilities </p>
                </div>
            </div>
            <div className="container">

                <h1>Facilities</h1>

                <h2>Dental Treatments</h2>
                <ol>
                    <li>Scaling and Polishing</li>
                    <li>Digital X-ray</li>
                    <li>Tooth Extraction</li>
                    <li>Tooth Colour Filling</li>
                    <li>Crown and Bridges</li>
                    <li>Root Canal Treatment</li>
                    <li>Complete and Partial Denture</li>
                    <li>Teeth Whitening (Bleaching)</li>
                    <li>Pedodontic Treatment</li>
                    <li>Orthodontic Treatment</li>
                    <li>Aligners</li>
                    <li>Implant</li>
                    <li>Tobacco Cessation Counselling</li>
                </ol>

                <h2>Skin & Hair Treatments</h2>
                <ul>
                    <li>Hydra Facial</li>
                    <li>Chemical Peels</li>
                    <li>Hair PRP</li>
                    <li>Face PRP</li>
                    <li>Skin Polishing</li>
                    <li>Mole and Warts Removal</li>
                    <li>Microdermabrasion</li>
                    <li>Dandruff Treatment</li>
                    <li>Acne Treatment</li>
                </ul>

            </div>

        </>


    )
}

export default Facilities;

